import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { callParkDetailsEndpoint } from "../api";
import { ParkDetailsDTO } from "../types";

export const useGetParkDetails = (specificPark?: string) => {
  const { park } = useParams();

  const parkToUse = specificPark || (park as string);

  return useQuery<ParkDetailsDTO, Error>({
    queryKey: ["park-details", parkToUse],
    queryFn: () => callParkDetailsEndpoint(parkToUse),
  });
};
